import React, { useState } from 'react';
import MarketingNav from '../components/marketing/MarketingNav';
import Hero from '../components/marketing/Hero';
import TrustWall from '../components/marketing/TrustWall';
import DistrictFinder from '../components/marketing/DistrictFinder';
import FeatureGrid from '../components/marketing/FeatureGrid';
import DistrictShowcase from '../components/marketing/DistrictShowcase';
import HowItWorks from '../components/marketing/HowItWorks';
import DashboardPreview from '../components/marketing/DashboardPreview';
import TrustSecurity from '../components/marketing/TrustSecurity';
import Pricing from '../components/marketing/Pricing';
import LocalSupport from '../components/marketing/LocalSupport';
import References from '../components/marketing/References';
import SiteFooter from '../components/marketing/SiteFooter';
import RequestDemoModal from '../components/marketing/RequestDemoModal';
import { Container, SectionHeader } from '../components/ui';

// Valley Tickets marketing homepage. Self-contained (own nav + footer).
// District-first; the fan search is preserved inside the Hero.
function Home() {
  const [requestOpen, setRequestOpen] = useState(false);
  const openRequest = () => setRequestOpen(true);

  return (
    <div className="min-h-screen bg-white">
      <MarketingNav onRequestDemo={openRequest} />
      <main>
        <Hero onRequestDemo={openRequest} />
        <TrustWall />

        {/* Explore Your District (dedicated section) */}
        <section id="for-districts" className="bg-brand-900 text-white py-16 sm:py-24 relative overflow-hidden scroll-mt-16">
          <div className="absolute inset-0 bg-brand-mesh opacity-60" />
          <Container className="relative">
            <SectionHeader
              align="center"
              eyebrow="For districts"
              title="Explore your district"
              subtitle="Type your district and step into a sample Valley Tickets portal in your schools' colors, with your mascots and example events. These are interactive demos, not live accounts."
            />
            <div className="mt-2">
              <DistrictFinder variant="section" />
            </div>
            <p className="text-center text-brand-200 text-sm mt-5">
              Don't see yours? <a href="/demo" className="text-accent-300 font-medium hover:text-accent-200">Browse all districts →</a>
            </p>
          </Container>
        </section>

        <FeatureGrid />
        <DistrictShowcase />
        <HowItWorks />
        <DashboardPreview />
        <TrustSecurity />
        <Pricing />
        <LocalSupport onRequestDemo={openRequest} />
        <References onRequestDemo={openRequest} />
      </main>
      <SiteFooter onRequestDemo={openRequest} />

      <RequestDemoModal open={requestOpen} onClose={() => setRequestOpen(false)} />
    </div>
  );
}

export default Home;
